<script>
  import { BellSolid } from 'flowbite-svelte-icons';
  import Layout from '../components/Layout.svelte';
  import { Button } from 'flowbite-svelte';
  import { sendDebugEvent } from '../data/debug.js';
  import { addToast } from '../store';
  import { _ } from 'svelte-i18n';
  import { TOAST_SUCCESS } from '../constants';
  import { getCookie, setCookie } from '../utils';
  import { onMount } from 'svelte';

  const USER_NOTIFY_OPT_IN = 'user_notify_geolocation_opt_in';

  onMount(() => {
    sendDebugEvent('creator-geolocation-visit');
  });

  let userOptedIn = getCookie(USER_NOTIFY_OPT_IN) ?? false;

  function sendCreatorNotificationRequest() {
    sendDebugEvent('creator-geolocation-notify');
    addToast({
      type: TOAST_SUCCESS,
      message: $_('geolocation.notification.toast', {
        default: 'Success! You will be notified about any future updates',
      }),
    });

    setCookie(USER_NOTIFY_OPT_IN, true);
    userOptedIn = true;
  }
</script>

<Layout>
  <h2 class="mb-4 text-2xl font-bold">
    {$_('geolocation.heading1', {
      default: 'New Feature: Coming Soon',
    })}
  </h2>

  <div class="w-full max-w-7xl rounded-md bg-[#F4F2FF] px-10 py-7">
    <p
      class="leading-wide mb-4 w-fit rounded-md bg-[#977DFF] px-4 py-1 text-sm font-bold uppercase text-white"
    >
      {$_('geolocation.heading2', {
        default: 'Coming Soon',
      })}
    </p>
    <h3 class="mb-3 text-lg font-bold">
      {$_('geolocation.heading3', {
        default: 'Earn Internationally',
      })}
    </h3>
    <p class="mb-6">
      {$_('geolocation.body.textblock1', {
        default: 'Ever worry about',
      })}
      <span class="font-bold"
        >{$_('geolocation.body.textblock2', {
          default: 'losing commissions',
        })}</span
      >
      {$_('geolocation.body.textblock3', {
        default:
          'on your product links that are clicked outside of your country?',
      })}

      <span class="font-bold"
        >{$_('geolocation.body.textblock4', {
          default: "We're building support for a new feature",
        })}
      </span>
      {$_('geolocation.body.textblock5', {
        default:
          'that automatically redirects your international visitors when they click on your affiliate links.',
      })}
    </p>

    <div
      class="flex w-full flex-col items-center rounded-md bg-white px-12 py-4"
    >
      <h3 class="mb-5 text-xl font-bold">
        {$_('geolocation.heading4', {
          default: 'With a one-time set-up, PostTap will:',
        })}
      </h3>
      <div
        class="mb-6 flex flex-col justify-center gap-4 lg:flex-row lg:justify-between"
      >
        <div
          class="flex flex-col items-center rounded-md bg-[#F4F2FF] px-2 py-4"
        >
          <svg
            width="106"
            height="104"
            viewBox="0 0 106 104"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mb-4"
          >
            <g clip-path="url(#clip0_6373_9293)">
              <path
                d="M53.2187 86.2007C51.9057 86.2189 50.7547 87.0588 49.8034 87.9717C46.9067 90.7884 43.5129 97.0873 39.48 100.555C32.9121 106.731 26.0139 104.437 26.0783 94.9943C25.9726 89.668 28.3887 84.272 28.7471 79.5166C29.6752 70.6599 18.6764 73.231 13.0036 72.8924C7.28614 73.0368 -2.09424 70.5188 0.416002 63.5194C5.62476 51.041 30.8857 53.871 18.2536 39.4125C14.3627 34.682 7.17715 26.8096 11.0499 20.7181C13.1142 18.089 17.0117 18.1271 20.0735 18.806C26.2765 20.0243 31.4241 24.7879 36.9896 25.0352C43.0158 24.7165 43.0324 15.4681 44.5352 10.8721C45.7622 5.49768 50.0759 -2.47768 56.0443 0.73902C60.2424 3.38475 61.6379 8.67122 62.6882 13.3635C63.6114 17.5711 63.9912 20.8326 65.9829 23.4966C69.9877 28.1225 77.0643 22.2219 81.5662 20.5156C85.8634 18.4956 92.5205 16.8275 95.5576 20.6517C96.9299 22.4144 97.0654 25.1398 96.0315 28.0926C94.2562 33.6944 88.5867 38.2423 85.6272 43.1022C80.8016 51.2286 94.8656 52.9913 100.04 57.1408C103.879 59.5226 108.333 64.8241 104.573 69.0732C98.3056 75.4783 87.2539 71.0981 80.3144 73.6144C75.0396 76.2219 79.0378 84.3765 79.748 88.9344C80.3029 91.4722 80.5968 94.0615 80.4251 96.3719C79.4375 107.654 70.0439 104.634 64.7625 98.3986C61.0054 94.8084 57.7123 86.5144 53.288 86.199H53.2137L53.2187 86.2007Z"
                fill="#6660FF"
                fill-opacity="0.1"
              />
            </g>
            <path
              d="M64.7651 22.8119C63.1094 22.26 62.5575 21.7081 62.0057 20.0524C61.9268 19.8159 61.6114 19.8159 61.5326 20.0524C60.9807 21.7081 60.4288 22.26 58.7731 22.8119C58.5366 22.8907 58.5366 23.2061 58.7731 23.2849C60.4288 23.8368 60.9807 24.3887 61.5326 26.0444C61.6114 26.281 61.9268 26.281 62.0057 26.0444C62.5575 24.3887 63.1094 23.8368 64.7651 23.2849C64.9228 23.2061 64.9228 22.8907 64.7651 22.8119Z"
              fill="#977DFF"
            />
            <path
              d="M81.9531 47.6476C79.509 46.8592 78.5629 45.9919 77.7744 43.469C77.6956 43.1536 77.2225 43.1536 77.1437 43.469C76.3553 45.9131 75.488 46.8592 72.965 47.6476C72.6497 47.7265 72.6497 48.1995 72.965 48.2784C75.4092 49.0668 76.3553 49.9341 77.1437 52.457C77.2225 52.7724 77.6956 52.7724 77.7744 52.457C78.5629 50.0129 79.4301 49.0668 81.9531 48.2784C82.3473 48.1995 82.3473 47.7265 81.9531 47.6476Z"
              fill="#977DFF"
            />
            <path
              d="M68.1569 53.1676C67.2108 52.2214 65.7128 52.2214 64.7666 53.1676L63.0321 54.9021L49.2346 68.6207C45.9232 71.9321 40.4831 71.9321 37.1717 68.6207C33.8603 65.3093 33.8603 59.8692 37.1717 56.5578L51.048 42.8392L52.7826 41.1046C53.7287 40.1585 53.7287 38.6605 52.7826 37.7144L47.1059 32.0377C46.1598 31.0916 44.6618 31.0916 43.7156 32.0377L27.001 48.7524L27.0798 48.8312C19.8263 57.1885 20.1417 69.8822 28.1048 77.8453C36.0679 85.8084 48.6827 86.045 57.0401 78.7914L57.1189 78.8703L73.8335 62.1556C74.7797 61.2095 74.7797 59.7115 73.8335 58.7654L68.1569 53.1676Z"
              fill="#6660FF"
            />
            <path
              d="M48.8403 44.9672L39.7734 35.9791L43.6367 32.1158C44.5828 31.1697 46.0809 31.1697 46.9481 32.1158L52.6248 37.7925C53.5709 38.7386 53.5709 40.2366 52.6248 41.1039L48.8403 44.9672Z"
              fill="#EEF2FF"
            />
            <path
              d="M69.8924 66.0968L60.9043 57.0299L64.7676 53.1666C65.7137 52.2205 67.2117 52.2205 68.079 53.1666L73.7557 58.8433C74.7018 59.7894 74.7018 61.2874 73.7557 62.1547L69.8924 66.0968Z"
              fill="#EEF2FF"
            />
            <path
              d="M85.9375 22.142L77.612 29.4522L84.7192 33.615L65.5299 40.8236C65.1237 40.9252 64.8191 40.519 65.1237 40.2144L73.4493 32.9042L66.3421 28.7415L85.5314 21.5328C85.9375 21.4313 86.2421 21.9389 85.9375 22.142Z"
              fill="#977DFF"
            />
            <defs>
              <clipPath id="clip0_6373_9293">
                <rect width="106" height="104" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p class="max-w-[23ch] text-center text-base font-bold sm:text-lg">
            {$_('geolocation.block1.text', {
              default: 'Match visitors to their local Amazon store.',
            })}
          </p>
        </div>
        <div
          class="flex flex-col items-center rounded-md bg-[#F4F2FF] px-2 py-4"
        >
          <svg
            width="106"
            height="104"
            viewBox="0 0 106 104"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mb-4"
          >
            <g clip-path="url(#clip0_6373_9297)">
              <path
                d="M53.2187 86.2007C51.9057 86.2189 50.7547 87.0588 49.8034 87.9717C46.9067 90.7884 43.5129 97.0873 39.48 100.555C32.9121 106.731 26.0139 104.437 26.0783 94.9943C25.9726 89.668 28.3887 84.272 28.7471 79.5166C29.6752 70.6599 18.6764 73.231 13.0036 72.8924C7.28614 73.0368 -2.09424 70.5188 0.416002 63.5194C5.62476 51.041 30.8857 53.871 18.2536 39.4125C14.3627 34.682 7.17715 26.8096 11.0499 20.7181C13.1142 18.089 17.0117 18.1271 20.0735 18.806C26.2765 20.0243 31.4241 24.7879 36.9896 25.0352C43.0158 24.7165 43.0324 15.4681 44.5352 10.8721C45.7622 5.49768 50.0759 -2.47768 56.0443 0.73902C60.2424 3.38475 61.6379 8.67122 62.6882 13.3635C63.6114 17.5711 63.9912 20.8326 65.9829 23.4966C69.9877 28.1225 77.0643 22.2219 81.5662 20.5156C85.8634 18.4956 92.5205 16.8275 95.5576 20.6517C96.9299 22.4144 97.0654 25.1398 96.0315 28.0926C94.2562 33.6944 88.5867 38.2423 85.6272 43.1022C80.8016 51.2286 94.8656 52.9913 100.04 57.1408C103.879 59.5226 108.333 64.8241 104.573 69.0732C98.3056 75.4783 87.2539 71.0981 80.3144 73.6144C75.0396 76.2219 79.0378 84.3765 79.748 88.9344C80.3029 91.4722 80.5968 94.0615 80.4251 96.3719C79.4375 107.654 70.0439 104.634 64.7625 98.3986C61.0054 94.8084 57.7123 86.5144 53.288 86.199H53.2137L53.2187 86.2007Z"
                fill="#6660FF"
                fill-opacity="0.1"
              />
              <path
                d="M78.3213 50.9045C77.5347 50.5113 77.2987 50.1967 77.1414 49.3315C77.1189 49.2079 76.9616 49.1854 76.9054 49.2977C76.5122 50.0843 76.1976 50.3203 75.3324 50.4776C75.2088 50.5001 75.1863 50.6574 75.2986 50.7136C76.0852 51.1068 76.3212 51.4214 76.4785 52.2867C76.501 52.4103 76.6583 52.4327 76.7145 52.3204C77.1077 51.5338 77.4223 51.2978 78.2875 51.1405C78.3718 51.1124 78.3943 50.9551 78.3213 50.9045Z"
                fill="#977DFF"
              />
              <path
                d="M85.1246 64.5159C83.9617 63.9484 83.5515 63.4484 83.338 62.1338C83.3212 61.9708 83.0852 61.9371 83.0234 62.0888C82.456 63.2518 81.9559 63.6619 80.6413 63.8755C80.4784 63.8923 80.4446 64.1283 80.5963 64.1901C81.7593 64.7575 82.1695 65.2575 82.383 66.5722C82.3998 66.7351 82.6358 66.7688 82.6976 66.6171C83.265 65.4541 83.765 65.044 85.0797 64.8305C85.2819 64.8193 85.3157 64.5833 85.1246 64.5159Z"
                fill="#977DFF"
              />
              <path
                d="M88.9288 52.0797L84.2551 55.1329L87.5036 57.7157L77.4181 59.9442C77.2083 59.9659 77.0853 59.7416 77.259 59.6114L81.9327 56.5582L78.6842 53.9754L88.7697 51.7469C88.9795 51.7252 89.0952 52.0001 88.9288 52.0797Z"
                fill="#977DFF"
              />
            </g>
            <path
              d="M48.6266 32.3109C49.3197 31.6178 50.3187 31.3254 51.2761 31.5355L68.2757 35.2671C69.3711 35.5076 70.2269 36.3635 70.4675 37.4589L74.1991 54.4584C74.4092 55.4159 74.1168 56.4149 73.4236 57.108L45.8465 84.6852C44.1624 86.3692 41.4318 86.3691 39.7477 84.6852L21.0494 65.9869C19.3656 64.3027 19.3654 61.5721 21.0494 59.8881L48.6266 32.3109ZM57.7243 40.5704C55.6702 42.6245 55.6704 45.9546 57.7243 48.0088C59.7786 50.0631 63.1093 50.0637 65.1635 48.0095C67.2177 45.9553 67.217 42.6246 65.1628 40.5704C63.1086 38.5165 59.7785 38.5163 57.7243 40.5704Z"
              fill="#6660FF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M85.277 28.3377C86.3545 28.4723 87.1187 29.455 86.9841 30.5324C86.7374 32.506 86.179 34.1365 85.2851 35.4423C84.3795 36.765 83.2048 37.6444 81.9098 38.217C79.5902 39.2427 76.7776 39.299 74.4223 39.3462C74.2945 39.3487 74.1681 39.3512 74.0431 39.3539C71.3886 39.4104 69.2336 39.5128 67.5618 40.3002C66.1163 40.981 64.8137 42.2919 64.2502 45.485C64.0615 46.5543 63.0417 47.2682 61.9724 47.0795C60.9031 46.8908 60.1892 45.871 60.3779 44.8017C61.1251 40.5674 63.0994 38.0554 65.8864 36.7428C68.4402 35.5401 71.4641 35.4757 73.9395 35.4231L73.9595 35.4226C76.6653 35.3651 78.7509 35.3144 80.3196 34.6208C81.0316 34.3059 81.5976 33.8678 82.0404 33.221C82.4947 32.5573 82.8921 31.5663 83.0823 30.0447C83.217 28.9672 84.1996 28.203 85.277 28.3377Z"
              fill="#977DFF"
            />
            <defs>
              <clipPath id="clip0_6373_9297">
                <rect width="106" height="104" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <p class="max-w-[23ch] text-center text-base font-bold sm:text-lg">
            {$_('geolocation.block2.text', {
              default: 'Map to either the exact or best matching product.',
            })}
          </p>
        </div>
        <div
          class="flex flex-col items-center rounded-md bg-[#F4F2FF] px-2 py-4"
        >
          <svg
            width="106"
            height="104"
            viewBox="0 0 106 104"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mb-4"
          >
            <g clip-path="url(#clip0_6373_9304)">
              <path
                d="M53.2187 86.2007C51.9057 86.2189 50.7547 87.0588 49.8034 87.9717C46.9067 90.7884 43.5129 97.0873 39.48 100.555C32.9121 106.731 26.0139 104.437 26.0783 94.9943C25.9726 89.668 28.3887 84.272 28.7471 79.5166C29.6752 70.6599 18.6764 73.231 13.0036 72.8924C7.28614 73.0368 -2.09424 70.5188 0.416002 63.5194C5.62476 51.041 30.8857 53.871 18.2536 39.4125C14.3627 34.682 7.17715 26.8096 11.0499 20.7181C13.1142 18.089 17.0117 18.1271 20.0735 18.806C26.2765 20.0243 31.4241 24.7879 36.9896 25.0352C43.0158 24.7165 43.0324 15.4681 44.5352 10.8721C45.7622 5.49768 50.0759 -2.47768 56.0443 0.73902C60.2424 3.38475 61.6379 8.67122 62.6882 13.3635C63.6114 17.5711 63.9912 20.8326 65.9829 23.4966C69.9877 28.1225 77.0643 22.2219 81.5662 20.5156C85.8634 18.4956 92.5205 16.8275 95.5576 20.6517C96.9299 22.4144 97.0654 25.1398 96.0315 28.0926C94.2562 33.6944 88.5867 38.2423 85.6272 43.1022C80.8016 51.2286 94.8656 52.9913 100.04 57.1408C103.879 59.5226 108.333 64.8241 104.573 69.0732C98.3056 75.4783 87.2539 71.0981 80.3144 73.6144C75.0396 76.2219 79.0378 84.3765 79.748 88.9344C80.3029 91.4722 80.5968 94.0615 80.4251 96.3719C79.4375 107.654 70.0439 104.634 64.7625 98.3986C61.0054 94.8084 57.7123 86.5144 53.288 86.199H53.2137L53.2187 86.2007Z"
                fill="#6660FF"
                fill-opacity="0.1"
              />
            </g>
            <path
              d="M76.1337 40.1987C79.9043 34.8915 77.6891 29.5749 76.5013 27.4822C76.3401 27.1982 76.0872 26.9774 75.7841 26.8558C75.481 26.7342 75.1456 26.7191 74.8328 26.8129C72.2986 27.7655 70.002 29.258 68.1022 31.1869C67.8734 31.3975 67.5823 31.528 67.2728 31.5586C66.9633 31.5892 66.6522 31.5183 66.3866 31.3565C63.1718 29.3979 59.5691 28.1627 55.8288 27.7367C55.6289 27.7141 55.4264 27.7341 55.2348 27.7954C55.0431 27.8567 54.8666 27.958 54.717 28.0925C54.5673 28.227 54.4479 28.3917 54.3666 28.5757C54.2852 28.7597 54.2438 28.9589 54.2451 29.1602V31.0455C54.2451 31.4255 54.0942 31.7899 53.8255 32.0586C53.5567 32.3274 53.1923 32.4783 52.8123 32.4783C52.4323 32.4783 52.0678 32.3274 51.7991 32.0586C51.5304 31.7899 51.3794 31.4255 51.3794 31.0455V29.1602C51.3782 28.9572 51.3341 28.7567 51.2501 28.572C51.1661 28.3872 51.044 28.2222 50.8919 28.0879C50.7397 27.9535 50.5609 27.8528 50.3672 27.7923C50.1734 27.7318 49.9691 27.7129 49.7675 27.7367C45.8949 28.1886 42.1737 29.5064 38.8798 31.5922C38.6101 31.7801 38.284 31.8695 37.9561 31.8454C37.6283 31.8214 37.3187 31.6854 37.0793 31.4602C35.1158 29.4093 32.72 27.8217 30.0659 26.8129C29.7566 26.7181 29.4242 26.7308 29.123 26.8489C28.8217 26.967 28.5693 27.1835 28.4068 27.4634C27.1814 29.5749 24.8059 35.2309 29.1233 40.67C29.2933 40.8803 29.4003 41.1344 29.432 41.403C29.4637 41.6716 29.4188 41.9436 29.3024 42.1877C26.7655 47.3538 26.0038 53.2126 27.1355 58.8556C28.2672 64.4986 31.229 69.6107 35.5616 73.3992C35.7078 73.525 35.8267 73.6793 35.911 73.8528C35.9953 74.0263 36.0432 74.2151 36.0518 74.4078L36.4666 82.8917C36.4837 83.266 36.6477 83.6184 36.923 83.8725C37.1983 84.1266 37.5627 84.262 37.9371 84.2492H42.5656C42.9456 84.2492 43.31 84.0982 43.5788 83.8295C43.8475 83.5608 43.9984 83.1963 43.9984 82.8163V80.29C43.999 80.0691 44.0505 79.8514 44.1491 79.6538C44.2477 79.4561 44.3907 79.284 44.5668 79.1507C44.743 79.0175 44.9475 78.9268 45.1645 78.8857C45.3815 78.8445 45.6051 78.8541 45.8178 78.9137C50.3705 80.1707 55.1787 80.1707 59.7314 78.9137C59.9425 78.8623 60.1626 78.8595 60.3749 78.9056C60.5873 78.9517 60.7863 79.0455 60.9571 79.18C61.1278 79.3144 61.2657 79.4858 61.3604 79.6814C61.4551 79.877 61.5041 80.0916 61.5036 80.3089V82.8163C61.5061 83.1972 61.6591 83.5616 61.9294 83.8301C62.1996 84.0985 62.565 84.2492 62.9459 84.2492H67.5649C67.9412 84.2595 68.3066 84.1224 68.5831 83.867C68.8596 83.6116 69.0253 83.2582 69.0449 82.8823L69.4502 74.4926C69.4609 74.2981 69.5107 74.1077 69.5965 73.9328C69.6823 73.7579 69.8025 73.6021 69.9498 73.4746C74.3836 69.6297 77.3958 64.4057 78.502 58.6422C79.6082 52.8787 78.7441 46.9107 76.0488 41.6975C75.924 41.464 75.8659 41.2006 75.8809 40.9362C75.8958 40.6718 75.9833 40.4167 76.1337 40.1987Z"
              fill="#6660FF"
            />
            <path
              d="M41.9346 47.7286C43.2986 47.7286 44.4044 46.6228 44.4044 45.2588C44.4044 43.8948 43.2986 42.7891 41.9346 42.7891C40.5706 42.7891 39.4648 43.8948 39.4648 45.2588C39.4648 46.6228 40.5706 47.7286 41.9346 47.7286Z"
              fill="#EEF2FF"
            />
            <path
              d="M63.6416 47.7286C65.0057 47.7286 66.1114 46.6228 66.1114 45.2588C66.1114 43.8948 65.0057 42.7891 63.6416 42.7891C62.2776 42.7891 61.1719 43.8948 61.1719 45.2588C61.1719 46.6228 62.2776 47.7286 63.6416 47.7286Z"
              fill="#EEF2FF"
            />
            <path
              d="M52.7751 48.5312C51.0338 48.5312 49.3315 49.0476 47.8837 50.0151C46.4358 50.9825 45.3073 52.3576 44.6409 53.9664C43.9745 55.5752 43.8002 57.3455 44.1399 59.0534C44.4796 60.7612 45.3181 62.33 46.5495 63.5614C47.7808 64.7927 49.3496 65.6312 51.0575 65.971C52.7654 66.3107 54.5357 66.1363 56.1445 65.4699C57.7533 64.8035 59.1283 63.6751 60.0958 62.2272C61.0632 60.7793 61.5796 59.077 61.5796 57.3357C61.5796 56.1795 61.3519 55.0346 60.9094 53.9664C60.4669 52.8982 59.8184 51.9276 59.0008 51.11C58.1833 50.2924 57.2127 49.6439 56.1445 49.2014C55.0763 48.759 53.9314 48.5312 52.7751 48.5312ZM49.3156 59.8432C48.8271 59.8432 48.3496 59.6983 47.9435 59.4269C47.5373 59.1556 47.2207 58.7698 47.0338 58.3185C46.8469 57.8672 46.798 57.3707 46.8933 56.8916C46.9886 56.4125 47.2238 55.9724 47.5692 55.627C47.9146 55.2816 48.3547 55.0464 48.8338 54.9511C49.3128 54.8558 49.8094 54.9047 50.2607 55.0916C50.712 55.2786 51.0977 55.5951 51.3691 56.0013C51.6405 56.4074 51.7854 56.8849 51.7854 57.3734C51.7755 58.0219 51.5109 58.6404 51.0488 59.0955C50.5867 59.5505 49.9641 59.8055 49.3156 59.8055V59.8432ZM56.2347 59.8432C55.7467 59.8487 55.268 59.7095 54.859 59.4432C54.45 59.1769 54.1291 58.7953 53.9368 58.3468C53.7445 57.8982 53.6894 57.4027 53.7784 56.9228C53.8675 56.443 54.0967 56.0003 54.4372 55.6506C54.7777 55.3009 55.2141 55.06 55.6914 54.9581C56.1687 54.8563 56.6655 54.8982 57.1191 55.0785C57.5726 55.2588 57.9625 55.5694 58.2397 55.9711C58.5168 56.3729 58.6687 56.8477 58.6762 57.3357C58.6762 57.9858 58.4199 58.6098 57.9628 59.0722C57.5058 59.5345 56.8848 59.798 56.2347 59.8055V59.8432Z"
              fill="#EEF2FF"
            />
            <path
              d="M80.216 22.4987C79.3623 22.2875 79.0631 22.0323 78.7199 21.2227C78.6708 21.107 78.5124 21.1196 78.4823 21.2415C78.2711 22.0952 78.0159 22.3944 77.2062 22.7376C77.0906 22.7867 77.1031 22.9451 77.2251 22.9753C78.0787 23.1864 78.378 23.4417 78.7212 24.2513C78.7702 24.367 78.9286 24.3544 78.9588 24.2324C79.17 23.3788 79.4252 23.0796 80.2349 22.7363C80.3109 22.6904 80.2983 22.532 80.216 22.4987Z"
              fill="#977DFF"
            />
            <path
              d="M89.8388 34.2874C88.5797 33.9888 88.0699 33.5909 87.5733 32.3551C87.5211 32.1998 87.2835 32.2187 87.2565 32.3802C86.9579 33.6394 86.56 34.1492 85.3242 34.6458C85.1689 34.698 85.1878 34.9356 85.3493 34.9626C86.6084 35.2612 87.1182 35.6591 87.6149 36.8949C87.667 37.0502 87.9047 37.0313 87.9317 36.8698C88.2302 35.6106 88.6281 35.1008 89.864 34.6042C90.0588 34.5489 90.04 34.3113 89.8388 34.2874Z"
              fill="#977DFF"
            />
            <path
              d="M90.8229 21.3176L86.9325 25.3215L90.6684 27.129L81.3172 31.5151C81.1172 31.5823 80.948 31.3904 81.0889 31.2253L84.9793 27.2214L81.2434 25.4139L90.5946 21.0278C90.7945 20.9606 90.9678 21.2034 90.8229 21.3176Z"
              fill="#977DFF"
            />
            <defs>
              <clipPath id="clip0_6373_9304">
                <rect width="106" height="104" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <p class="max-w-[23ch] text-center text-base font-bold sm:text-lg">
            {$_('geolocation.block3.text', {
              default:
                'Preserve your Amazon Store ID and earnings in the process!',
            })}
          </p>
        </div>
      </div>
      <p class="mb-4">
        {$_('geolocation.block4.text', {
          default: "Interested? Sign up to be notified when it's available.",
        })}
      </p>
      <Button
        disabled={userOptedIn}
        on:click={sendCreatorNotificationRequest}
        class="flex gap-2"
      >
        <BellSolid size="sm" />
        {#if userOptedIn}
          {$_('geolocation.button.disabled.text', {
            default: "You'll be Notified",
          })}
        {:else}
          {$_('geolocation.button.text', {
            default: 'Notify Me',
          })}
        {/if}
      </Button>
    </div>
  </div>
</Layout>
